import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgMicrophoneOnSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8 13V15M13 9.25C12.69 11.25 10.57 12.75 8 12.75C5.43 12.75 3.31 11.22 3 9.25M8 1C9.51878 1 10.75 2.23122 10.75 3.75V7.25C10.75 8.76878 9.51878 10 8 10C6.48122 10 5.25 8.76878 5.25 7.25V3.75C5.25 2.23122 6.48122 1 8 1Z"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgMicrophoneOnSmall.displayName = 'SvgMicrophoneOnSmall';
const MicrophoneOnSmall = withForgeIconProps(SvgMicrophoneOnSmall, {
  name: 'MicrophoneOn',
  usage: 'Use to indicate a live microphone, or to mute.',
  related: 'audio, mic',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default MicrophoneOnSmall;
